import { init } from "./init";
import { sanitizeData, sanitizeExpire } from "./Sanitize";
import appConf from "../../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];

const actionTypes = {
  SET_PRODUCT_BREAK: "SET_PRODUCT_BREAK",
};

const setFilter = ({ products, cat }) => {
  return products.filter((prod) => prod.subclassId === cat);
};

const setMapper = ({ cards, carriers }) => {
  console.log(cards, carriers, " cccccc --->");
  const MappedCards = [];
  const mapper = setup.setup.reducerMapper;

  cards.map((card, index) => {
    const mapped_carrier_id = mapper[card.productId];
    const carrier_id = carriers[0].productId;
    if (carrier_id === mapped_carrier_id) {
      MappedCards.push({
        card,
        carrier: carriers[0],
        carriernone: carriers[0],
      });
    }
  });
  return MappedCards;
};
const setProductBreak = async (state, products) => {
  const cards = setFilter({ products, cat: 3 });
  const carriers = setFilter({ products, cat: 2 });
  const couriers = setFilter({ products, cat: 5 });
  const mapped = setMapper({ cards, carriers });
  const data = {
    cards,
    carriers,
    couriers,
    mapped,
  };
  state = {
    ...state,
    data,
  };
  return state;
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_PRODUCT_BREAK:
      return setProductBreak(state, action.products);
    default:
      return state;
  }
};

const productbreak = {
  init,
  actionTypes,
  reducer,
};

export default productbreak;
